var exports = {
  "wx": "PlutoniumSectionHeader.module__header___dTk0Wn",
  "Pd": "PlutoniumSectionHeader.module__headerCenter___dTk0Wn",
  "DD": "PlutoniumSectionHeader.module__title___dTk0Wn",
  "h_": "PlutoniumSectionHeader.module__description___dTk0Wn",
};

module.exports = exports;
